import styled from "@emotion/styled";

const TabContentContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-top: 2rem;
`
export default TabContentContainer